import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'planning-top-nav',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './planning-top-nav.component.html',
  styleUrls: ['./planning-top-nav.component.scss'],
})
export class PlanningTopNavComponent implements AfterViewInit {
  @ViewChildren('navLink', { read: ElementRef })
  navLinks!: QueryList<ElementRef<HTMLAnchorElement>>;

  isHidden = false;
  private lastScrollY = 0;

  constructor(private router: Router) {}

  ngAfterViewInit(): void {
    setTimeout(() => this.scrollToActive(false), 0);

    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe(() => {
        setTimeout(() => this.scrollToActive(true), 0);
      });

    this.navLinks.changes.subscribe(() => {
      setTimeout(() => this.scrollToActive(false), 0);
    });
  }

  @HostListener('window:scroll')
  onScroll(): void {
    const current = window.scrollY;

    if (current < 30) {
      this.isHidden = false;
      this.lastScrollY = current;
      return;
    }

    if (current > this.lastScrollY) {
      this.isHidden = true;
    } else {
      this.isHidden = false;
      setTimeout(() => this.scrollToActive(false), 0);
    }

    this.lastScrollY = current;
  }

  private scrollToActive(smooth = true): void {
    if (!this.navLinks?.length) return;

    const activeLink = this.navLinks.find((link) =>
      link.nativeElement.classList.contains('active'),
    );

    if (!activeLink) return;

    activeLink.nativeElement.scrollIntoView({
      behavior: smooth ? 'smooth' : 'auto',
      inline: 'center',
      block: 'nearest',
    });
  }
}